<template>
    <div>

        <section  v-if="!showRecipes" >
        <!--<div>-->
            <h3 class="section-title section-title__test">Тест</h3>

            <div  v-if="this.testNum <= 5"  class="test-container valign">

                <!--<h3 class="test-question">Выберите блюдо, которое вам больше нравится:</h3>-->
                <div class="text-container text-container__test">
                    <div class="text-main">
                        <p>
                            Из нескольких пар блюд, приготовленных на гриле, выберите те, которые вам больше нравятся.
                            По результатам теста мы расскажем, как часто вы можете устраивать и посещать BBQ-мероприятия без последствий для вашего организма.
                        </p>
                    </div>

                </div>


                <div class="test-answer clearfix active" v-if="this.testNum==1" data-number="1">
                    <a href="#" @click.prevent="selectAnswer(0)" class="test-item left">
                        <span class="test-image">
                        </span>
                        <span class="test-text">Ананас на гриле</span>
                    </a>
                    <a href="#" @click.prevent="selectAnswer(10)" class="test-item left">
                        <span class="test-image">
                        </span>
                        <span class="test-text">Говяжьи шашлычки</span>
                    </a>
                </div>
                <div class="test-answer clearfix active" v-if="this.testNum==2" data-number="2">
                  <a href="#" @click.prevent="selectAnswer(0)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Порей с чесночным майонезом</span>
                  </a>
                  <a href="#" @click.prevent="selectAnswer(10)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Ягненок тандури</span>
                  </a>
                </div>
                <div class="test-answer clearfix active" v-if="this.testNum==3" data-number="3">
                  <a href="#" @click.prevent="selectAnswer(0)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Персики на гриле с горгонзолой и медом</span>
                  </a>
                  <a href="#" @click.prevent="selectAnswer(10)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Сэндвич с яичницей</span>
                  </a>
                </div>
                <div class="test-answer clearfix active" v-if="this.testNum==4" data-number="4">
                  <a href="#" @click.prevent="selectAnswer(0)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Дорада на гриле с мандаринами и майораном</span>
                  </a>
                  <a href="#" @click.prevent="selectAnswer(10)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Шаверма в пите</span>
                  </a>
                </div>
                <div class="test-answer clearfix active" v-if="this.testNum==5" data-number="5">
                  <a href="#" @click.prevent="selectAnswer(0)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Зажаренная на гриле капуста</span>
                  </a>
                  <a href="#" @click.prevent="selectAnswer(10)" class="test-item left">
                        <span class="test-image">
                        </span>
                    <span class="test-text">Цыпленок гриль с орегано</span>
                  </a>
                </div>
                <div class="test-progress">
                    <span :class="[this.testNum===1 ? 'active' : '', '', this.testNum>1 ? 'done' : '', '']">1</span>
                    <span :class="[this.testNum===2 ? 'active' : '', '', this.testNum>2 ? 'done' : '', '']">2</span>
                    <span :class="[this.testNum===3 ? 'active' : '', '', this.testNum>3 ? 'done' : '', '']">3</span>
                    <span :class="[this.testNum===4 ? 'active' : '', '', this.testNum>4 ? 'done' : '', '']">4</span>
                    <span :class="[this.testNum===5 ? 'active' : '', '']">5</span>
                </div>

            </div>

            <template v-if="this.testNum > 5 && this.bal > 30">
                <div  class="text-container text-container__result valign">
                    <div class="result-top">
                        <h3 class="text-title">Будьте внимательнее!</h3>
                        <div class="text-main">
                            <p>
                                Судя по вашим кулинарным предпочтениям, вашему кишечнику понадобится помощь уже на второй день выходных.
                            </p>
                        </div>


                        <div class="social-wrapper">
                            <social-sharing inline-template class="social" url="http://baktistatin.eda.ru/share-1.html">
                                <div>
                                    <a href="#" class="fb">
                                        <network network="facebook">
                                            <img src="/static/svg/fb.svg" alt="Facebook">
                                        </network>
                                    </a>
                                    <a href="#" class="tw">
                                        <network network="twitter">
                                            <img src="/static/svg/twitter.svg" alt="Twitter">
                                        </network>
                                    </a>
                                    <a href="#" class="vk">
                                        <network network="vk">
                                            <img src="/static/svg/vk.svg" alt="Vkontakte">
                                        </network>
                                    </a>
                                </div>
                            </social-sharing>
                            <a href="#" class="ok" @click.prevent="shareOk">
                                <span>
                                    <img src="/static/svg/ok.svg" alt="Ok">
                                </span>
                            </a>
                        </div>

                    </div>
                    <div class="result-bottom clearfix">
                        <div class="text-main">
                            <p>Позаботьтесь об этом заранее – храните БАКТИСТАТИН ® при себе!</p>
                            <span>узнать больше</span><Arrow></Arrow>
                        </div>
                        <div class="image-right">
                            <a href="http://www.bactistatin.com/about/" target="_blank" @click="gaRedirect">
                                <img src="/static/images/baktistatin.png" alt="Baktistatin">
                            </a>
                            <img class="shadow" src="/static/images/shadow.png" alt="Baktistatin">
                        </div>
                    </div>
                    <a href="#" class="btn btn-hover" @click.prevent = "recShow"><span>далее</span></a>
                </div>
            </template>

            <template v-if="this.testNum > 5 && this.bal > 10 && this.bal <= 30">
                <div class="text-container text-container__result valign">
                    <div class="result-top">
                        <h3 class="text-title">Неплохой результат!</h3>
                        <div class="text-main">
                            <p>
                                Похоже, что ваше меню на выходные находится в разумном балансе между сытостью и полезностью. Однако не стоит забывать, что и при таком режиме ваш кишечник может перетрудиться.
                            </p>
                        </div>
                        <div class="social-wrapper">
                            <social-sharing inline-template class="social" url="http://baktistatin.eda.ru/share-2.html">
                                <div>
                                    <a href="#" class="fb">
                                        <network network="facebook">
                                            <img src="/static/svg/fb.svg" alt="Facebook">
                                        </network>
                                    </a>
                                    <a href="#" class="tw">
                                        <network network="twitter">
                                            <img src="/static/svg/twitter.svg" alt="Twitter">
                                        </network>
                                    </a>
                                    <a href="#" class="vk">
                                        <network network="vk">
                                            <img src="/static/svg/vk.svg" alt="Vkontakte">
                                        </network>
                                    </a>
                                </div>
                            </social-sharing>
                            <a href="#" class="ok" @click.prevent="shareOk">
                                <span>
                                    <img src="/static/svg/ok.svg" alt="Ok">
                                </span>
                            </a>
                        </div>

                    </div>
                    <div class="result-bottom clearfix">
                        <div class="text-main">
                            <p>Поэтому, возьмите с собой на выходные упаковку препарата БАКТИСТАТИН ®.</p>
                            <span>узнать больше</span><Arrow></Arrow>
                        </div>
                        <div class="image-right">
                            <a href="http://www.bactistatin.com/about/" target="_blank" @click="gaRedirect">
                                <img src="/static/images/baktistatin.png" alt="Baktistatin">
                            </a>
                            <img class="shadow" src="/static/images/shadow.png" alt="Baktistatin">
                        </div>
                    </div>
                    <a href="#" class="btn btn-hover" @click.prevent = "recShow"><span>далее</span></a>
                </div>
            </template>

            <template v-if="this.testNum > 5 && this.bal <= 10">
                <div class="text-container text-container__result valign">
                    <div class="result-top">
                        <h3 class="text-title">Хороший результат!</h3>
                        <div class="text-main">
                            <p>
                                Вы сможете провести почти месяц BBQ сезона без последствий для кишечника. Однако, потом вам все равно потребуется период восстановления.
                            </p>
                        </div>
                        <div class="social-wrapper">
                            <social-sharing inline-template class="social" url="http://baktistatin.eda.ru/share-3.html">
                                <div>
                                    <a href="#" class="fb">
                                        <network network="facebook">
                                            <img src="/static/svg/fb.svg" alt="Facebook">
                                        </network>
                                    </a>
                                    <a href="#" class="tw">
                                        <network network="twitter">
                                            <img src="/static/svg/twitter.svg" alt="Twitter">
                                        </network>
                                    </a>
                                    <a href="#" class="vk">
                                        <network network="vk">
                                            <img src="/static/svg/vk.svg" alt="Vkontakte">
                                        </network>
                                    </a>
                                </div>
                            </social-sharing>
                            <a href="#" class="ok" @click.prevent="shareOk">
                                <span>
                                    <img src="/static/svg/ok.svg" alt="Ok">
                                </span>
                            </a>
                        </div>

                    </div>
                    <div class="result-bottom clearfix">
                        <div class="text-main">
                            <p>Лучше иметь БАКТИСТАТИН ®
                                под рукой для себя или увлекающихся BBQ близких.</p>
                            <span>узнать больше</span><Arrow></Arrow>
                        </div>
                        <div class="image-right">
                            <a href="http://www.bactistatin.com/about/" target="_blank" @click="gaRedirect">
                                <img src="/static/images/baktistatin.png" alt="Baktistatin">
                            </a>
                            <img class="shadow" src="/static/images/shadow.png" alt="Baktistatin">
                        </div>
                    </div>
                    <a href="#" class="btn btn-hover" @click.prevent = "recShow"><span>далее</span></a>
                </div>
            </template>
        <!--</div>-->

        </section>
        <section v-if="showRecipes"  class="scrollable">
            <h3 class="section-title">Рецепты</h3>
            <div class="text-container text-container-relative">
                <h3 class="text-title">Мы подобрали рецепты на твой вкус:</h3>
            </div>

            <div v-if = "this.bal > 30" class="recipes-wrap">
                <div class="recipes-container">
                    <div class="recipes-col">
                        <div class="recipes-item">
                            <!--<router-link :to="{name: 'Recipe', params: { RecipeItem[13].index }}"></router-link>-->
                            <router-link :to="{name: 'Recipe', params: { id: 11 }}"></router-link>
                            <img :src=" RecipeItem[11].image " alt="">
                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">1</span>
                                <span class="recipes-name">{{RecipeItem[11].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[11].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[11].time}}</span>
                            </div>
                        </div>
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 13 }}"></router-link>
                            <img :src=" RecipeItem[13].image " alt="">
                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">3</span>
                                <span class="recipes-name">{{RecipeItem[13].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[13].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[13].time}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="recipes-col">
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 17 }}"></router-link>
                            <img :src=" RecipeItem[17].image " alt="">
                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">2</span>
                                <span class="recipes-name">{{RecipeItem[17].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[17].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[17].time}}</span>
                            </div>
                        </div>
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 18 }}"></router-link>
                            <img :src=" RecipeItem[18].image " alt="">
                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">4</span>
                                <span class="recipes-name">{{RecipeItem[18].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[18].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[18].time}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recipe-button">
                    <router-link class="btn btn-hover" to="/recipes" @click.native = "gaMore"><span>больше рецептов</span></router-link>
                </div>
            </div>
            <div v-if = "this.bal > 10 && this.bal <= 30" class="recipes-wrap">
                <div class="recipes-container">
                    <div class="recipes-col">
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 3 }}"></router-link>
                            <img :src=" RecipeItem[3].image " alt="">

                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">1</span>
                                <span class="recipes-name">{{RecipeItem[3].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[3].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[3].time}}</span>
                            </div>
                        </div>
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 8 }}"></router-link>
                            <img :src=" RecipeItem[8].image " alt="">

                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">3</span>
                                <span class="recipes-name">{{RecipeItem[8].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[8].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[8].time}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="recipes-col">
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 11 }}"></router-link>
                            <img :src=" RecipeItem[11].image " alt="">
                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">2</span>
                                <span class="recipes-name">{{RecipeItem[11].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[11].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[11].time}}</span>
                            </div>
                        </div>
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 17 }}"></router-link>
                            <img :src=" RecipeItem[17].image " alt="">
                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">4</span>
                                <span class="recipes-name">{{RecipeItem[17].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[17].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[17].time}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recipe-button">
                    <router-link class="btn btn-hover" to="/recipes" @click.native = "gaMore"><span>больше рецептов</span></router-link>
                </div>
            </div>
            <div v-if = "this.bal <= 10" class="recipes-wrap">
                <div class="recipes-container">
                    <div class="recipes-col">
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 1 }}"></router-link>
                            <img :src=" RecipeItem[1].image " alt="">

                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">1</span>
                                <span class="recipes-name">{{RecipeItem[1].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[1].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[1].time}}</span>
                            </div>
                        </div>
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 2 }}"></router-link>
                            <img :src=" RecipeItem[2].image " alt="">

                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">3</span>
                                <span class="recipes-name">{{RecipeItem[2].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[2].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[2].time}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="recipes-col">
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 3 }}"></router-link>
                            <img :src=" RecipeItem[3].image " alt="">

                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">2</span>
                                <span class="recipes-name">{{RecipeItem[3].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[3].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[3].time}}</span>
                            </div>
                        </div>
                        <div class="recipes-item">
                            <router-link :to="{name: 'Recipe', params: { id: 8 }}"></router-link>
                            <img :src=" RecipeItem[8].image " alt="">

                            <div class="recipes-info">
                                <span class="recipes-num recipes-num-round">4</span>
                                <span class="recipes-name">{{RecipeItem[8].name}}</span>
                                <span class="recipes-portions">{{RecipeItem[8].portion}}</span>
                                <span class="recipes-time">{{RecipeItem[8].time}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recipe-button">
                    <router-link class="btn btn-hover" to="/recipes" @click.native = "gaMore"><span>больше рецептов</span></router-link>
                </div>
            </div>

        </section>

    </div>

</template>

<script>
    import {TweenMax} from 'gsap';
    import Arrow from '../../assets/svg/arrow-long.svg';
    import Twitter from '../../assets/svg/twitter.svg';
    import FB from '../../assets/svg/fb.svg';
    import OK from '../../assets/svg/ok.svg';
    import VK from '../../assets/svg/vk.svg';
    import socialSharing from 'vue-social-sharing';
    import Helpers from '@/tools/Helpers';

    import Storage from '@/store/storage';

    export default {
        name: 'Test',
        data () {
          return {
            bal:0,
            testNum:1,
            showRecipes: false,
            RecipeItem: this.$store.state.RecipeDate,
          }
        },

        watch: {
            'testNum' () {
                if(this.testNum > 5){
                    ga('send', 'event', 'load', 'show', 'Test results loaded');
                }
            },
        },

        mounted(){

            function hideTitle() {

                if(Helpers.isMobile()){
                    return
                }

                var scrolled = window.pageYOffset || document.documentElement.scrollTop;
                if(scrolled > 0){
                    document.querySelector('.menu-btn.top').classList.add('hide');
                }else{
                    document.querySelector('.menu-btn.top').classList.remove('hide');
                }
            };


            window.onscroll = function() {
                hideTitle()
            }


        },
        components: {
            Arrow,
            Twitter,
            FB,
            VK,
            OK,
            Storage,
            socialSharing
        },
        methods: {
            selectAnswer(bal) {
                this.bal = this.bal + bal;
                this.testNum++;
            },

            recShow(){
                this.showRecipes = true;
                ga('send', 'event', 'click', 'show', 'Test result click Next');
            },

            gaRedirect(){
                ga('send', 'event', 'redirect', 'show', 'Test result Redirect');
            },
            gaMore(){
                ga('send', 'event', 'redirect', 'show', 'Test result click More');
            },
            shareOk () {
                Helpers.shareOk();
                ga('send', 'event', 'redirect', 'show', 'Odnoklassniki share click');
            },
        }
    }
</script>



// WEBPACK FOOTER //
// TestMain.vue?0050f730